import { Directive, ViewContainerRef } from '@angular/core';

@Directive({ selector: '[appNotificationTemplate]' })
export class NotificationTemplateDirective {
  constructor(public viewContainerRef: ViewContainerRef) {
  }
}
